export default __webpack_public_path__ + "static/media/gallery4.3039f3b8.jpg";